module.exports = __webpack_public_path__ + "static/media/blog-hai-thumb.ddbc9c23.jpg";